import { useNavigate } from "react-router-dom";

const useHandleClick = () => {
    const navigate = useNavigate();

    const handleClick = (e, path, callback) => {
        if (e.metaKey || e.ctrlKey) {
            // Allow Cmd or Ctrl + click for opening in a new tab
            return;
        }
        e.preventDefault();
        navigate(path);
        if (callback) callback();
    };

    return handleClick;
};

export default useHandleClick;
